<div>
  <!-- Botón de cerrar en la esquina superior izquierda -->
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button " (click)="closePopUp()">
    <i class="material-icons">close</i>
  </button>


  <div>

    <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">


      <form class="form-horizontal ng-untouched ng-pristine ng-valid" (ngSubmit)="onSubmit()" novalidate="">
        <div class="block">
          <div class="col-14">
            <div class="row justify-content-center">

              <div class="col-12 ml-2">
                <div class="row">
                  <div class="col-5 ">
                    <app-form-input-app [labelText]="'Nombre'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text"
                        [(ngModel)]="appAttendanceTypesModel.name" name="workCenterName" required="true">
                    </app-form-input-app>
                  </div>
                  <div class="col-5 mt-4 pt-1">
                    <app-dropdown-formularios dataSize="7" placeHolder="Habilitado"
                      [selectedValue]="appAttendanceTypesModel.enabled.toString()"
                      (selectedValueChange)="enabledSelectedChange($event)" [required]="true" [dropdownType]="'YesNo'">
                    </app-dropdown-formularios>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5 mt-4 pt-1">
                    <app-dropdown-formularios dataSize="7" placeHolder="Tipo"
                      [selectedValue]="appAttendanceTypesModel.entry?.toString()"
                      (selectedValueChange)="entrySelectedChange($event)" [required]="true" [dropdownType]="'Entry'">
                    </app-dropdown-formularios>
                  </div>
                  <div class="col-5 mt-4 pt-1">
                    <app-dropdown-formularios dataSize="7" placeHolder="Suma jornada" [isDisabled]="appAttendanceTypesModel.entry"
                      [selectedValue]="appAttendanceTypesModel.imputable?.toString()"
                      (selectedValueChange)="imputableSelectedChange($event)" [required]="true" [dropdownType]="'YesNo'">
                    </app-dropdown-formularios>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Botonera -->
        <div class="row">
          <label class="col-md-3"></label>
          <div class="col-md-9">
            <div class="form-group form-button">
              <button class="btn btn-fill btn-primary float-right" type="submit"
                [disabled]="!appAttendanceTypesModel.name">Guardar</button>
              <a class="btn btn-fill btn-outline-white float-right" (click)="closePopUp()">Volver</a>
            </div>
          </div>
        </div>
      </form>
    </app-generic-panel>

  </div>




</div>